import { Button } from '@sortlist-frontend/design-system';
import { ArrowRight, Zap } from '@sortlist-frontend/design-system/icons';

import { RichText } from '_features/RankingPage/components/RichText';

import type { GuidePageContent } from '../types';
import { RevealOnScroll } from './RevealOnScroll';

interface GuideShortAnswerProps {
  section: GuidePageContent['shortAnswer'];
}

export const GuideShortAnswer = (props: GuideShortAnswerProps) => {
  const { section } = props;

  return (
    <RevealOnScroll as="section" className="rounded-2xl border border-primary-200 bg-primary-50 p-5 md:p-7">
      <h2 id="short-answer-title" className="flex items-center gap-2 text-xl font-semibold text-secondary-950">
        <Zap size={20} className="text-primary-500" aria-hidden="true" />
        {section.title}
      </h2>
      <p className="mt-3 leading-relaxed text-secondary-700 md:text-lg">
        <RichText text={section.text} />
      </p>
      <div className="mt-5">
        <Button
          as="a"
          href={section.cta.href}
          color="primary"
          variant="solid"
          size="lg"
          hasShadow
          endContent={<ArrowRight />}>
          {section.cta.label}
        </Button>
      </div>
    </RevealOnScroll>
  );
};
